import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export enum HomeIconVariant {
  DEFAULT = 'default',
  SIDE_MENU = 'side_menu',
}

interface IHomeIconProps extends IConDefaultType {
  variant?: HomeIconVariant;
}

function HomeIcon({ color, className, size = 24, rotate, flip, variant = HomeIconVariant.DEFAULT }: IHomeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === HomeIconVariant.DEFAULT && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0855 4.56615C10.0851 4.56643 10.0847 4.56671 10.0842 4.56699L5.816 7.35585C5.25828 7.71932 4.80009 8.21625 4.48298 8.80158C4.16587 9.38691 3.99986 10.0421 4 10.7078V16.9981C4 17.7937 4.31607 18.5568 4.87868 19.1194C5.44129 19.682 6.20435 19.9981 7 19.9981H17C17.7956 19.9981 18.5587 19.682 19.1213 19.1194C19.6839 18.5568 20 17.7937 20 16.9981V10.7081C20.0001 10.0423 19.8341 9.38691 19.517 8.80158C19.1999 8.21625 18.7417 7.71932 18.184 7.35585L18.183 7.3552L13.9158 4.56699C13.9153 4.56669 13.9149 4.5664 13.9144 4.56611C13.3443 4.19662 12.6794 4 12 4C11.3206 4 10.6557 4.19663 10.0855 4.56615ZM8.99575 2.88914C9.89027 2.30882 10.9337 2 12 2C13.0663 2 14.1097 2.30882 15.0042 2.88914L15.007 2.89091L19.276 5.68028C19.2757 5.68009 19.2763 5.68046 19.276 5.68028C19.2761 5.68031 19.2769 5.68089 19.277 5.68092C20.1131 6.22608 20.8001 6.97123 21.2755 7.84888C21.7512 8.72681 22.0002 9.70957 22 10.7081C22 10.708 22 10.7081 22 10.7081V16.9981C22 18.3241 21.4732 19.5959 20.5355 20.5336C19.5979 21.4713 18.3261 21.9981 17 21.9981H7C5.67392 21.9981 4.40215 21.4713 3.46447 20.5336C2.52678 19.5959 2 18.3241 2 16.9981V10.7083C2 10.7082 2 10.7083 2 10.7083C1.99982 9.70978 2.24883 8.72682 2.72447 7.84888C3.20005 6.97105 3.88716 6.22577 4.72353 5.68058C4.72338 5.68068 4.72369 5.68048 4.72353 5.68058L8.99575 2.88914Z"
            fill={color || EColorMap.gray_0}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15.998C8 15.4458 8.44772 14.998 9 14.998H15C15.5523 14.998 16 15.4458 16 15.998C16 16.5503 15.5523 16.998 15 16.998H9C8.44772 16.998 8 16.5503 8 15.998Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
      {variant === HomeIconVariant.SIDE_MENU && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            d="M13 18.1065H19V9.56627L12 4.41246L5 9.56627V18.1065H11V12.4268H13V18.1065ZM21 19.0531C21 19.576 20.5523 19.9998 20 19.9998H4C3.44772 19.9998 3 19.576 3 19.0531V9.1033C3 8.81118 3.14247 8.53542 3.38606 8.35608L11.3861 2.466C11.7472 2.20013 12.2528 2.20013 12.6139 2.466L20.6139 8.35608C20.8575 8.53542 21 8.81118 21 9.1033V19.0531Z"
            fill={color || 'black'}
          />
        </svg>
      )}
    </i>
  );
}

export default HomeIcon;
